import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { AppStore } from '../app-store/app-store.service';
import { ApiOperations } from 'src/app/models';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AccessService {
  private apiOperations!: ApiOperations;

  constructor(private http: HttpClient, private appStore: AppStore) {
    const { operations } = this.appStore.env?.api || {};
    this.apiOperations = operations;
  }

  checkHasAccess(rut: string, email: string): Observable<{ codigo: string }> {
    if (!this.apiOperations) {
      return throwError(() => new Error('this.apiOperations is not set'));
    }
    const body = { rut, mail: email };
    const url = this.appStore.getUrlByOperation(this.apiOperations.sendCode);
    return this.http.post<any>(url, body).pipe(tap((result) => result));
  }

  validateCode(rut: string, code: string): Observable<any> {
    if (!this.apiOperations) {
      return throwError('this.this.apiOperations is not set');
    }
    const body = { rut: rut, codigo: code };
    const url = this.appStore.getUrlByOperation(
      this.apiOperations.getSchedulesByRut
    );
    return this.http.post<any>(url, body).pipe(tap((result) => result));
  }

  resendCode(rut: string, email: string): Observable<{ codigo: string }> {
    if (!this.apiOperations) {
      return throwError('this.this.apiOperations is not set');
    }
    const body = { rut, mail: email };
    const url = this.appStore.getUrlByOperation(this.apiOperations.resendCode);
    return this.http.post<any>(url, body).pipe(tap((result) => result));
  }
}
